// extracted by mini-css-extract-plugin
export default {"controls":"Controls_controls__4cZLn","interestPoints":"Controls_interestPoints__eWE0S","selected":"Controls_selected__afJOo"};